<template>
    <div class="window window-tasks window_full">
        <div class="window-header">
            <img src="@/assets/img/icons/icon-news.svg" alt="Иконка" class="window-header__icon" />
            <div class="window-header__title">Новостная лента</div>
        </div>
        <div class="window-body news">
            <StoriesMenuSlider />
            <div class="news-wrapper">
                <div v-for="(item, index) in newsList" :key="index" class="news-item">
                    <!-- <div class="news-item__image" :style="{ backgroundImage: `url(${item.image})` }"></div> -->
                    <img :src="item.image" class="news-item__image">
                    <div class="news-item-body">
                        <div class="news-item-body__title">{{ item.title }}</div>
                        <div class="news-item-body__subtitle">
                            {{ item.text.length > 120 ? item.text.substring(0, 117) + '...' : item.text }}
                        </div>
                        <div class="news-item-body__more" @click="$refs.newsModal.showModal(item.id)">
                            Подробнее
                        </div>
                        <div class="news-item-body-footer">
                            <div class="news-item-body-footer-item likes" :class="isLiked(item) ? 'active' : ''"
                                @click="reactionHandler(item, 1, 'news')">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M15.7 4C18.87 4 21 6.98 21 9.76C21 15.39 12.16 20 12 20C11.84 20 3 15.39 3 9.76C3 6.98 5.13 4 8.3 4C10.12 4 11.31 4.91 12 5.71C12.69 4.91 13.88 4 15.7 4Z"
                                        stroke="currentColor" stroke-width="1.1" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <span v-if="item.reactions_count != 0">
                                    {{ item.reactions_count }}
                                </span>
                            </div>
                            <div class="news-item-body-footer-item comments"
                                @click="$refs.newsModal.showModal(item.id)">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 8.5H9" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M6 3H18C19.6568 3 21 4.34315 21 6V15C21 16.6568 19.6568 18 18 18H7.5L3.80841 20.8926C3.65785 21.0106 3.45317 21.0324 3.28117 20.9486C3.10918 20.8649 3.00002 20.6904 3 20.4991V6C3 4.34315 4.34315 3 6 3Z"
                                        stroke="currentColor" stroke-width="1.1" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M12 12.5H9" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <span v-if="item.comments_count != 0">
                                    {{ item.comments_count }}
                                </span>
                            </div>
                            <div class="news-item-body-footer-item date">
                                {{ timeAgoSimple(item.created_at) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <dashboardNewsModal ref="newsModal" />
        <StoriesWrapper />
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import dashboardNewsModal from '@/components/dashboard/dashboardNewsModal.vue'
import StoriesMenuSlider from "@/components/dashboard/Stories/Menu/StoriesMenuSlider.vue";
import StoriesWrapper from '@/components/dashboard/Stories/Main/StoriesMainWrapper.vue';

export default {
    data() {
        return {
            newsLoading: true,
            newsList: []
        }
    },

    components: {
        dashboardNewsModal,
        StoriesMenuSlider,
        StoriesWrapper
    },

    computed: {
        ...mapState({
            stories: (state) => state.news.stories
        })
    },

    methods: {
        ...mapActions({
            fetchNews: 'news/fetchNews',
            setReaction: 'news/setReaction',
            delReaction: 'news/delReaction',
            fetchStories: 'news/fetchStories'
        }),

        initNews() {
            this.newsLoading = true

            this.fetchNews()
                .then((result) => {
                    this.newsList = result.slice(-3)
                    this.newsLoading = false
                })
        },

        isLiked(item) {
            if (item.user_reactions.length) {
                const reaction = item.user_reactions.find(x => x.reaction_type == 1)
                if (reaction) {
                    return reaction
                } else {
                    return false
                }
            } else {
                return false
            }
        },

        reactionHandler(item, reaction, type) {
            const isLiked = this.isLiked(item)
            if (isLiked) {
                this.delReaction(isLiked.id)
                    .then(() => {
                        this.initNews()
                    })
            } else {
                this.setReaction({ id: item.id, reaction: reaction, type: type })
                    .then(() => {
                        this.initNews()
                    })
            }
        },

        timeAgoSimple(dateString) {
            const date = new Date(dateString);
            const now = new Date();
            const seconds = Math.floor((now - date) / 1000);

            if (seconds < 60) return 'только что';

            const minutes = Math.floor(seconds / 60);
            if (minutes < 60) return `${minutes} мин. назад`;

            const hours = Math.floor(seconds / 3600);
            if (hours < 24) return `${hours} ч. назад`;

            const days = Math.floor(seconds / 86400);
            if (days < 7) return `${days} д. назад`;

            const weeks = Math.floor(days / 7);
            if (weeks < 4) return `${weeks} нед. назад`;

            const months = Math.floor(days / 30);
            if (months < 12) return `${months} мес. назад`;

            const years = Math.floor(days / 365);
            return `${years} г. назад`;
        }
    },

    mounted() {
        this.initNews()
        this.fetchStories()
    }
}
</script>
<style scoped lang="sass">
.news
    padding: 20px
    display: flex
    flex-direction: column
    gap: 20px
    &-wrapper
        display: grid
        grid-template-columns: 1fr
        grid-gap: 20px
        @media only screen and  (min-width: 1920px) 
            grid-template-columns: repeat(2, 1fr)
    &-item
        padding: 8px 0
        display: grid
        grid-template-columns: repeat(2, 1fr)
        grid-gap: 20px
        font-size: 14px
        font-weight: 500
        @media only screen and  (max-width: 1024px)
            grid-template-columns: 1fr

        &__image
            width: 100%
            // max-width: 100%
            // background-size: cover
            // background-repeat: no-repeat
            border-radius: 5px
            // aspect-ratio: 16/9
        &-body
            display: flex
            flex-direction: column
            gap: 12px
            &__title
                font-size: 18px
                font-weight: 700
            &__subtitle
                line-height: 20px
            &__more
                color: var(--color-blue)
                cursor: pointer
                &:hover
                    text-decoration: underline
            &-footer
                margin-top: 24px
                display: flex
                align-items: center
                gap: 12px
                &-item
                    display: flex
                    align-items: center
                    gap: 4px
                    color: var(--color-text-ligth)
                    cursor: pointer
                    &.likes
                        &:hover
                            color: var(--color-red) 
                        &.active svg
                            color: var(--color-red)
                            fill: var(--color-red)
                    &.comments
                        &:hover 
                            color: var(--color-blue)
                    &.date
                        margin-left: 12px
                        cursor: default
</style>